import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWidgetProps } from '../../WidgetPropsContext';
import { selectFilters } from '../filters/selectors';
import { fetchTimeslots } from './doctorsSlice';
import { selectTimeslots } from './selectors';
import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner';
import { DoctorItem } from './DoctorItem';

import './doctors.scss';
import { sortBy } from '../../utils';
import { filterDoctorsForChild } from '../filters/utils';

let isAssignmentsLoad = false;

export const Doctors = () => {
    const {
        baseUrl,
        assignmentIds: _assignmentIds,
    } = useWidgetProps();
    const dispatch = useDispatch();
    const {
        branch,
        date,
        doctor,
        specialization,
        isLoading: isBranchesOrDoctorsLoading,
        forChild,
        childrenAge,
        doctorsData,
    } = useSelector(selectFilters);
    const {
        timeslots: _timeslots,
        isLoading,
        timeslotsBranch,
        timeslotsSpeciality,
        timeslotDate,
    } = useSelector(selectTimeslots);
    const timeslots = useMemo(() => {
        const filteredByDoctor = !doctor ? _timeslots : _timeslots.filter(({ doctorId }) => doctorId === doctor);
        const result = !specialization
            ? filteredByDoctor
            : filteredByDoctor.filter(({ specialityId }) => specialityId === specialization);
        const childDoctorIds = new Set(filterDoctorsForChild(doctorsData, forChild, childrenAge)
            .map(item => `${item.doctorId}`));
        const filteredByChild = !forChild
            ? result
            : result.filter(({ doctorId }) => childDoctorIds.has(`${doctorId}`));

        return sortBy(filteredByChild, (r) => {
            const nts = (r?.nearestTimeslot ?? 'z').split(' ')
                .join('T');
            return r?.freeTimeslots?.length ? r?.freeTimeslots?.[0]?.startTime?.split(' ')
                .join('T') : nts;
        });
    }, [ doctor, specialization, _timeslots, forChild, childrenAge, doctorsData ]);

    useEffect(() => {
        if ((_assignmentIds && !isAssignmentsLoad && doctor )) {
            dispatch(
                fetchTimeslots({
                    branch,
                    date,
                    baseUrl,
                    specializationId: specialization,
                }),
            );
            isAssignmentsLoad = true;
        }
        if (!date || !branch || !baseUrl || isBranchesOrDoctorsLoading || doctor) {
            return;
        }
        // if (
        // !(_assignmentIds && !specialization && !isAssignmentsLoad) ||
        // isLoading
        // ) {
        if (((timeslotsSpeciality !== specialization) || (branch !== timeslotsBranch) || (date !== timeslotDate))) {// || (_assignmentIds && !isAssignmentsLoad)
            dispatch(
                fetchTimeslots({
                    branch,
                    date,
                    baseUrl,
                    specializationId: specialization,
                }),
            );
            isAssignmentsLoad = true;
        }
        // }
    }, [
        doctor,
        branch,
        date,
        dispatch,
        baseUrl,
        timeslotDate,
        specialization,
        timeslotsSpeciality,
        _assignmentIds,
    ]);

    useEffect(() => {
        _timeslots.filter(({ specialityId }) => specialityId === specialization);
    }, [ doctor, specialization, _timeslots ]);

    return isLoading ? (
        <LoadingSpinner />
    ) : (
        <ul>
            {branch && timeslots.map(doctorItem => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <DoctorItem key={doctorItem.doctorId} {...doctorItem} date={date} />
            ))}
        </ul>
    );
};
